import { FC } from 'react';

import './PanelSearch.scss';

interface IProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const PanelSearch: FC<IProps> = ({ value, onChange, placeholder = 'Filter...' }) => {
  const hasValue = value.length > 0;

  return (
    <div className="PanelSearch">
      <div className="PanelSearch-bar">
        <span className="material-icons PanelSearch-icon">search</span>
        <input
          className="PanelSearch-input"
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
        {hasValue ? (
          <button
            className="PanelSearch-clear"
            onClick={() => onChange('')}
            aria-label="Clear filter"
            type="button"
          >
            <span className="material-icons">close</span>
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default PanelSearch;
